import axios from "axios";
import { PROFILE_IMAGE } from "common/constants/apiUrls";
import { getGridConfiguration, getUserProfile } from "./UserManagementServices";
import i18next from "i18next";
export const fetchProfile = async (
  auth,
  setPermissions,
  setUserProfilePicture = null,
  setIsFetchingState = null
) => {
  const handleGridConfigurations = async () => {
    if (!localStorage.getItem("users") || !localStorage.getItem("branches")) {
      let resultConfiguration = await getGridConfiguration();

      if (resultConfiguration?.users) {
        localStorage.setItem(
          "users",
          JSON.stringify(resultConfiguration.users)
        );
      }
      if (resultConfiguration?.branches) {
        localStorage.setItem(
          "branches",
          JSON.stringify(resultConfiguration?.branches)
        );
      }
    }
  };
  let resultProfile = await getUserProfile();
  if (resultProfile?.success) {
    handleGridConfigurations();
    auth.performLogin();
    const menuStructure =
      resultProfile?.payLoad?.permissions?.menuStructures.filter(
        (el) => el.applicationKey === "#VdsManagement"
      ) || [];
    localStorage.setItem("menuStructure", JSON.stringify(menuStructure));
    setPermissions(resultProfile?.payLoad?.permissions?.claims);
    localStorage.setItem(
      "userPermissions",
      JSON.stringify(resultProfile?.payLoad?.permissions?.claims)
    );
    localStorage.setItem(
      "userRole",
      JSON.stringify(resultProfile?.payLoad?.role)
    );
    localStorage.setItem(
      "products",
      JSON.stringify(resultProfile?.payLoad?.products)
    );
    localStorage.setItem("userId", JSON.stringify(resultProfile?.payLoad?.id));
    localStorage.setItem(
      "applicationKeys",
      JSON.stringify(resultProfile?.payLoad?.applicationKeys)
    );
    localStorage.setItem("email", resultProfile?.payLoad?.email);
    if (resultProfile?.payLoad?.branchInfo) {
      localStorage.setItem(
        "branchId",

        resultProfile?.payLoad?.branchInfo?.branchId
      );
      localStorage.setItem(
        "bankId",

        resultProfile?.payLoad?.branchInfo?.bankId
      );
      localStorage.setItem(
        "branchName",
        resultProfile?.payLoad?.branchInfo?.branchName
      );
    }
    i18next.changeLanguage(resultProfile?.payLoad?.languagePreference);
    if (resultProfile?.payLoad?.profilePicture && setUserProfilePicture) {
      (() => {
        const url = process.env.REACT_APP_BASE_URL + PROFILE_IMAGE;
        axios.get(url, { responseType: "blob" }).then((response) => {
          try {
            if (response.status === 200) {
              setUserProfilePicture(URL.createObjectURL(response.data));
              setIsFetchingState(false);
            }
          } catch (e) {
            setIsFetchingState(false);
          }
        });
      })();
    } else setIsFetchingState && setIsFetchingState(false);

    const event = new CustomEvent("localdatachanged");
    document.dispatchEvent(event);
    if (!resultProfile?.payLoad?.permissions?.menuStructures) {
      return { route: "/unauthorized-user" };
    } else if (
      resultProfile?.payLoad?.role.roleTranslatedValue === "End User" ||
      resultProfile?.payLoad?.permissions?.menuStructures.filter(
        (el) => el.applicationKey === "#VdsManagement"
      ).length === 0
    ) {
      return { route: "/unauthorized-user" };
    } else {
      localStorage.setItem("userExists", true);
      return {
        route: menuStructure?.length
          ? menuStructure[0].route
          : "/unauthorized-user",
      };
    }
  } else return { route: null };
};
